import React from 'react';
import styles from '../../styles/components/Footer.module.scss';
import classnames from 'classnames';
import { normalizeAnchorHref } from '../../utils/anchors';

export default function Footer({ data }) {
  return (
    <div className={classnames(styles.footerWrapper, styles[data?.style])}>
      <ul className={styles.menu}>
        {data?.links.map((item, index) => {
          let menuItem;
          if (item.external) {
            menuItem = (
              <a
                href={item.url}
                target={item.newTab ? '_blank' : '_self'}
                rel="noreferrer"
              >
                {item.text}
              </a>
            );
          } else {
            menuItem = <a href={normalizeAnchorHref(`#${item.url}`)}>{item.text}</a>;
          }
          return <li key={index}>{menuItem}</li>;
        })}
        <li>
          <button
            type="button"
            className={styles.linkButton}
            onClick={() => window.DB_CMP?.showSecondLayer()}
          >
            Analyse verwalten
          </button>
        </li>
      </ul>
    </div>
  );
}
